import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./styles/global.css";
import i18n from "./i18n";
import { LanguageProvider } from "./contexts/LanguageProvider";
import App from "./App";

const appJsx = (
  <React.StrictMode>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById("root") as HTMLElement;

// react-snap pre-renders pages into static HTML at build time.
// If the root already has children, hydrate to attach React to existing markup.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appJsx);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(appJsx);
}
